import { render, staticRenderFns } from "./ListClient.vue?vue&type=template&id=12a4de92&"
import script from "./ListClient.vue?vue&type=script&lang=js&"
export * from "./ListClient.vue?vue&type=script&lang=js&"
import style0 from "./ListClient.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports